import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useNavigate, useParams, Link } from "react-router-dom";
import AddImage from "../../Global Functions/addImage";
import { useDispatch, useSelector } from "react-redux";
import { editCategory, viewCategory } from "../../Redux/Actions/categoryResaleActions";
import toast from "react-hot-toast";
import "./editCategories.css";

const UploadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const UploadField = ({ label, fieldKey, value, onUpload, onRemove, loading }) => (
  <div className="ab-field">
    <label className="ab-label">
      {label} <span className="ab-optional">(Optional)</span>
    </label>
    {value ? (
      <div className="aa-image-preview">
        <img src={value} alt={label} className="aa-preview-img" />
        <div className="aa-preview-info">
          <span className="aa-preview-label">Uploaded</span>
          <button type="button" className="aa-remove-btn" onClick={() => onRemove(fieldKey)} disabled={loading}>
            <TrashIcon />
            Remove
          </button>
        </div>
      </div>
    ) : (
      <label className="aa-upload-zone" htmlFor={`upload-${fieldKey}`}>
        <input
          id={`upload-${fieldKey}`}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={(e) => onUpload(e, fieldKey)}
          disabled={loading}
        />
        <div className="aa-upload-icon"><UploadIcon /></div>
        <span className="aa-upload-text">Click to upload</span>
        <span className="aa-upload-hint">PNG, JPG, SVG up to 2MB</span>
      </label>
    )}
  </div>
);

const EditCategories = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState(0);

  const [categoryState, setCategoryState] = useState({
    id: id,
    name: "",
    position: "",
    icon: "",
    three_d_icon: "",
    image: "",
    type: [],
  });

  useEffect(() => {
    dispatch(viewCategory(id));
  }, [id, dispatch]);

  const { category } = useSelector((state) => state.categoriesResale || {});

  console.log("DATATA", category)

  useEffect(() => {
    if (category?.data) {
      setCategoryState((prev) => ({ ...prev, ...category.data, id: id }));
    }
  }, [id, category]);

  const handleImageUpload = async (event, type) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) return;
    const responseUrl = await AddImage(uploadedImage);
    if (responseUrl) {
      setCategoryState((prev) => ({ ...prev, [type]: responseUrl }));
    }
  };

  const handleRemove = (fieldKey) => {
    setCategoryState((prev) => ({ ...prev, [fieldKey]: "" }));
  };

  const handleNextSection = () => {
    const next = Math.min(sections.length - 1, activeSection + 1);
    if (activeSection === 0 && !categoryState.name.trim()) {
      toast.error("Category name is required");
      return;
    }
    setActiveSection(next);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!categoryState.name.trim()) return toast.error("Category name is required");

    setLoading(true);
    try {
      const filteredData = Object.fromEntries(
        Object.entries(categoryState).filter(([_, value]) => value !== "" && value !== null && value !== undefined)
      );
      const response = await dispatch(editCategory(filteredData));
      if (response?.statusCode === 200) {
        toast.success("Category updated successfully!");
        navigate("/categories_resale");
      } else {
        toast.error(response?.message || "Failed to update category");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const sections = ["Basic Info", "Media"];

  return (
    <MainLayout>
      <div className="ab-wrapper">
        <div className="ab-header">
          <div className="ab-header-left">
            <div className="ab-header-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </div>
            <div>
              <h1 className="ab-title">Edit Category</h1>
              <p className="ab-subtitle">Update the details for this category</p>
            </div>
          </div>
          <Link to="/categories_resale" className="ab-view-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
            </svg>
            View Category List
          </Link>
        </div>

        <div className="ab-nav">
          {sections.map((sec, i) => (
            <button
              key={i}
              className={`ab-nav-pill ${activeSection === i ? "ab-nav-pill--active" : ""}`}
              onClick={() => setActiveSection(i)}
              type="button"
              disabled={loading}
            >
              <span className="ab-nav-num">{String(i + 1).padStart(2, "0")}</span>
              {sec}
            </button>
          ))}
        </div>

        <form className="ab-form">
          <div className={`ab-section ${activeSection === 0 ? "ab-section--visible" : ""}`}>
            <div className="ab-section-header">
              <span className="ab-section-badge">01</span>
              <h2 className="ab-section-title">Basic Information</h2>
            </div>
            <div className="ab-grid ab-grid-2">
              <div className="ab-field">
                <label className="ab-label">Category Name <span className="ab-req">*</span></label>
                <input
                  className="ab-input"
                  type="text"
                  name="name"
                  value={categoryState.name}
                  onChange={(e) => setCategoryState((prev) => ({ ...prev, name: e.target.value }))}
                  placeholder="e.g. Residential"
                  disabled={loading}
                />
              </div>
            </div>
          </div>

          <div className={`ab-section ${activeSection === 1 ? "ab-section--visible" : ""}`}>
            <div className="ab-section-header">
              <span className="ab-section-badge">02</span>
              <h2 className="ab-section-title">Media</h2>
            </div>
            <div className="ab-grid ab-grid-2">
              <UploadField
                label="Category Image"
                fieldKey="image"
                value={categoryState.image}
                onUpload={handleImageUpload}
                onRemove={handleRemove}
                loading={loading}
              />
              <UploadField
                label="Category Icon"
                fieldKey="icon"
                value={categoryState.icon}
                onUpload={handleImageUpload}
                onRemove={handleRemove}
                loading={loading}
              />
              <UploadField
                label="3D Icon"
                fieldKey="three_d_icon"
                value={categoryState.three_d_icon}
                onUpload={handleImageUpload}
                onRemove={handleRemove}
                loading={loading}
              />
            </div>
          </div>

          <div className="ab-footer">
            <div className="ab-footer-nav">
              <button
                type="button"
                className="ab-btn ab-btn--ghost"
                onClick={() => setActiveSection((s) => Math.max(0, s - 1))}
                disabled={activeSection === 0 || loading}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
                Back
              </button>

              {activeSection < sections.length - 1 ? (
                <button type="button" className="ab-btn ab-btn--primary" onClick={handleNextSection} disabled={loading}>
                  Next
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </button>
              ) : (
                <button type="button" onClick={handleSubmit} className="ab-btn ab-btn--submit" disabled={loading}>
                  {loading ? (
                    "Saving..."
                  ) : (
                    <>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                      Save Changes
                    </>
                  )}
                </button>
              )}
            </div>
            <Link to="/categories" className="ab-btn ab-btn--cancel">
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditCategories;